import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarSungageApplicationStateDto } from "../dto/solar-sungage.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The stored Solar Sungage application and what Start can do. Never calls
 * Sungage; the status drawer posts Refresh for a live check.
 */
export default function useSolarSungageApplication(
  proposalId: string | undefined,
): UseQueryResult<SolarSungageApplicationStateDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.sungageApplication(proposalId ?? ``),
    queryFn: () => solarProposalService.getSungageApplication(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: 1,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
